// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";

const getLocation = (
  locale: string,
  slug: string,
  path?: string
): ((apiInstance: AxiosInstance) => AxiosPromise) => (apiInstance) => {
  debug("getLocation", slug, locale, path);

  return apiInstance(`/v5/geo/${locale}/${slug}`, {
    params: {
      path
    }
  });
};

export default getLocation;
